export const PATIENT_SECONDARY_INSURANCE_POLICY_OPTIONS = {
  SECONDARY_INSURANCE_POLICY_CARRIER:
    "Patient.SecondaryInsurancePolicy.Carrier",
  SECONDARY_INSURANCE_POLICY_MEMBER_ID:
    "Patient.SecondaryInsurancePolicy.MemberID",
  SECONDARY_INSURANCE_POLICY_GROUP_NUMBER:
    "Patient.SecondaryInsurancePolicy.GroupNumber",
  SECONDARY_INSURANCE_POLICY_PLAN: "Patient.SecondaryInsurancePolicy.Plan",
  SECONDARY_INSURANCE_POLICY_COMPANY_CONTACT_NUMBER:
    "Patient.SecondaryInsurancePolicy.CompanyContactNumber",
  SECONDARY_INSURANCE_POLICY_NOTES: "Patient.SecondaryInsurancePolicy.Notes",
  SECONDARY_INSURANCE_POLICY_HOLDER_RELATION_TO_ISSUER:
    "Patient.SecondaryInsurancePolicy.Holder.RelationToInsurer",
  SECONDARY_INSURANCE_POLICY_HOLDER_FIRST_NAME:
    "Patient.SecondaryInsurancePolicy.Holder.FirstName",
  SECONDARY_INSURANCE_POLICY_HOLDER_LAST_NAME:
    "Patient.SecondaryInsurancePolicy.Holder.LastName",
  SECONDARY_INSURANCE_POLICY_HOLDER_FULL_NAME:
    "Patient.SecondaryInsurancePolicy.Holder.FullName",
  SECONDARY_INSURANCE_POLICY_HOLDER_MIDDLE_INITIAL:
    "Patient.SecondaryInsurancePolicy.Holder.MiddleInitial",
  SECONDARY_INSURANCE_POLICY_HOLDER_SEX:
    "Patient.SecondaryInsurancePolicy.Holder.Sex",
  SECONDARY_INSURANCE_POLICY_HOLDER_DATE_OF_BIRTH:
    "Patient.SecondaryInsurancePolicy.Holder.DateOfBirth",
  SECONDARY_INSURANCE_POLICY_HOLDER_EMPLOYER_NAME:
    "Patient.SecondaryInsurancePolicy.Holder.EmployerName",
  SECONDARY_INSURANCE_POLICY_HOLDER_FULL_ADDRESS:
    "Patient.SecondaryInsurancePolicy.Holder.FullAddress",
  SECONDARY_INSURANCE_POLICY_HOLDER_ADDRESS_LINE1:
    "Patient.SecondaryInsurancePolicy.Holder.AddressLine1",
  SECONDARY_INSURANCE_POLICY_HOLDER_ADDRESS_LINE2:
    "Patient.SecondaryInsurancePolicy.Holder.AddressLine2",
  SECONDARY_INSURANCE_POLICY_HOLDER_CITY:
    "Patient.SecondaryInsurancePolicy.Holder.City",
  SECONDARY_INSURANCE_POLICY_HOLDER_STATE:
    "Patient.SecondaryInsurancePolicy.Holder.State",
  SECONDARY_INSURANCE_POLICY_HOLDER_ZIP_CODE:
    "Patient.SecondaryInsurancePolicy.Holder.ZIPCode",
  SECONDARY_INSURANCE_POLICY_HOLDER_PHONE_NUMBER:
    "Patient.SecondaryInsurancePolicy.Holder.PhoneNumber",
  SECONDARY_INSURANCE_POLICY_BENEFITS_HEARING_AID_BENEFIT:
    "Patient.SecondaryInsurancePolicy.Benefits.HearingAidBenefit",
  SECONDARY_INSURANCE_POLICY_BENEFITS_DEDUCTIBLE:
    "Patient.SecondaryInsurancePolicy.Benefits.Deductible",
  SECONDARY_INSURANCE_POLICY_COPAY: "Patient.SecondaryInsurancePolicy.CoPay"
};

export const PATIENT_SECONDARY_INSURANCE_POLICY_MENU_OPTIONS = {
  title: "Patient - Secondary Insurance Policy",
  menu: [
    {
      title: "Policy Details",
      menu: [
        {
          title: "Patient - Secondary Insurance Policy - Carrier",
          value:
            PATIENT_SECONDARY_INSURANCE_POLICY_OPTIONS.SECONDARY_INSURANCE_POLICY_CARRIER
        },
        {
          title: "Patient - Secondary Insurance Policy - Member ID",
          value:
            PATIENT_SECONDARY_INSURANCE_POLICY_OPTIONS.SECONDARY_INSURANCE_POLICY_MEMBER_ID
        },
        {
          title: "Patient - Secondary Insurance Policy - Group Number",
          value:
            PATIENT_SECONDARY_INSURANCE_POLICY_OPTIONS.SECONDARY_INSURANCE_POLICY_GROUP_NUMBER
        },
        {
          title: "Patient - Secondary Insurance Policy - Plan/Program Name",
          value:
            PATIENT_SECONDARY_INSURANCE_POLICY_OPTIONS.SECONDARY_INSURANCE_POLICY_PLAN
        },
        {
          title:
            "Patient - Secondary Insurance Policy - Company Contact Number",
          value:
            PATIENT_SECONDARY_INSURANCE_POLICY_OPTIONS.SECONDARY_INSURANCE_POLICY_COMPANY_CONTACT_NUMBER
        },
        {
          title: "Patient - Secondary Insurance Policy - Notes",
          value:
            PATIENT_SECONDARY_INSURANCE_POLICY_OPTIONS.SECONDARY_INSURANCE_POLICY_NOTES
        }
      ]
    },
    {
      title: "Policy Holder Details",
      menu: [
        {
          title:
            "Patient - Secondary Insurance Policy - Holder Relation to Insurer",
          value:
            PATIENT_SECONDARY_INSURANCE_POLICY_OPTIONS.SECONDARY_INSURANCE_POLICY_HOLDER_RELATION_TO_ISSUER
        },
        {
          title: "Patient - Secondary Insurance Policy - Holder First Name",
          value:
            PATIENT_SECONDARY_INSURANCE_POLICY_OPTIONS.SECONDARY_INSURANCE_POLICY_HOLDER_FIRST_NAME
        },
        {
          title: "Patient - Secondary Insurance Policy - Holder Last Name",
          value:
            PATIENT_SECONDARY_INSURANCE_POLICY_OPTIONS.SECONDARY_INSURANCE_POLICY_HOLDER_LAST_NAME
        },
        {
          title: "Patient - Secondary Insurance Policy - Holder Full Name",
          value:
            PATIENT_SECONDARY_INSURANCE_POLICY_OPTIONS.SECONDARY_INSURANCE_POLICY_HOLDER_FULL_NAME
        },
        {
          title: "Patient - Secondary Insurance Policy - Holder Middle Initial",
          value:
            PATIENT_SECONDARY_INSURANCE_POLICY_OPTIONS.SECONDARY_INSURANCE_POLICY_HOLDER_MIDDLE_INITIAL
        },
        {
          title: "Patient - Secondary Insurance Policy - Holder Sex",
          value:
            PATIENT_SECONDARY_INSURANCE_POLICY_OPTIONS.SECONDARY_INSURANCE_POLICY_HOLDER_SEX
        },
        {
          title: "Patient - Secondary Insurance Policy - Holder Date of Birth",
          value:
            PATIENT_SECONDARY_INSURANCE_POLICY_OPTIONS.SECONDARY_INSURANCE_POLICY_HOLDER_DATE_OF_BIRTH
        },
        {
          title: "Patient - Secondary Insurance Policy - Holder Employer Name",
          value:
            PATIENT_SECONDARY_INSURANCE_POLICY_OPTIONS.SECONDARY_INSURANCE_POLICY_HOLDER_EMPLOYER_NAME
        },
        {
          title: "Patient - Secondary Insurance Policy - Holder Full Address",
          value:
            PATIENT_SECONDARY_INSURANCE_POLICY_OPTIONS.SECONDARY_INSURANCE_POLICY_HOLDER_FULL_ADDRESS
        },
        {
          title: "Patient - Secondary Insurance Policy - Holder Address Line 1",
          value:
            PATIENT_SECONDARY_INSURANCE_POLICY_OPTIONS.SECONDARY_INSURANCE_POLICY_HOLDER_ADDRESS_LINE1
        },
        {
          title: "Patient - Secondary Insurance Policy - Holder Address Line 2",
          value:
            PATIENT_SECONDARY_INSURANCE_POLICY_OPTIONS.SECONDARY_INSURANCE_POLICY_HOLDER_ADDRESS_LINE2
        },
        {
          title: "Patient - Secondary Insurance Policy - Holder City",
          value:
            PATIENT_SECONDARY_INSURANCE_POLICY_OPTIONS.SECONDARY_INSURANCE_POLICY_HOLDER_CITY
        },
        {
          title: "Patient - Secondary Insurance Policy - Holder State",
          value:
            PATIENT_SECONDARY_INSURANCE_POLICY_OPTIONS.SECONDARY_INSURANCE_POLICY_HOLDER_STATE
        },
        {
          title: "Patient - Secondary Insurance Policy - Holder ZIP Code",
          value:
            PATIENT_SECONDARY_INSURANCE_POLICY_OPTIONS.SECONDARY_INSURANCE_POLICY_HOLDER_ZIP_CODE
        },
        {
          title: "Patient - Secondary Insurance Policy - Holder Phone Number",
          value:
            PATIENT_SECONDARY_INSURANCE_POLICY_OPTIONS.SECONDARY_INSURANCE_POLICY_HOLDER_PHONE_NUMBER
        }
      ]
    },
    {
      title: "Policy Benefits",
      menu: [
        {
          title: "Patient - Secondary Insurance Policy - Hearing Aid Benefit",
          value:
            PATIENT_SECONDARY_INSURANCE_POLICY_OPTIONS.SECONDARY_INSURANCE_POLICY_BENEFITS_HEARING_AID_BENEFIT
        },
        {
          title: "Patient - Secondary Insurance Policy - Deductible",
          value:
            PATIENT_SECONDARY_INSURANCE_POLICY_OPTIONS.SECONDARY_INSURANCE_POLICY_BENEFITS_DEDUCTIBLE
        },
        {
          title: "Patient - Secondary Insurance Policy - Co-pay",
          value:
            PATIENT_SECONDARY_INSURANCE_POLICY_OPTIONS.SECONDARY_INSURANCE_POLICY_COPAY
        }
      ]
    }
  ]
};
